import { createAction, props } from '@ngrx/store';
import { QuickApplicationFormValue } from './quick-application.models';

const formUpdated = createAction(
  '[Quick Application] Form Updated',
  props<{ formValue: QuickApplicationFormValue }>()
);

const cleared = createAction('[Quick Application] Cleared');

export const QuickApplicationActions = {
  formUpdated,
  cleared
};
